//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    error: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      title: '',
    }
  },

  computed: {},

  created() {
    this.setTitle();
  },

  methods: {
    setTitle() {
      let title = ''

      if (this.error.statusCode === 401) {
        title = 'ページにアクセスできません。再度読み込みしてください。'
      } else if (this.error.statusCode === 403) {
        title = 'このページはご利用いただけません。'
      } else if (this.error.statusCode === 404) {
        title = 'ページが見つかりません。'
      } else {
        title = 'エラーが発生しました'
      }

      this.title = title
    },
    
    goHome() {
      this.$router.push('/')
    }
  },
}
